import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ApplyCreditCard } from "../../../../core/models/orders/applyCreditCard";
import { CustomerPaymentMethodDto } from "../../../../core/models/orders/customerPaymentMethodDto";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { AddClientContact } from "../../../../core/models/client/addClientContact";
import { CommonModule } from "@angular/common";
import { AddContactInformationComponent } from "../../../clients/components/add-contact-information/add-contact-information.component";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { Currency } from "../../../../core/models/shared/currencyList";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { ClientAddressCustomize } from "../../../../core/models/client/details/clientAddresscustomize";

@Component({
  selector: "jni-header-details",
  templateUrl: "./header-details.component.html",
  imports: [
    CommonModule,
    AddContactInformationComponent,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
    CheckboxModule,
  ],
  styleUrls: ["./header-details.component.scss"],
})
export class HeaderDetailsComponent {
  @Input() parent!: FormGroup;
  @Input() shippingProductsList: ShippingMethod[] = [];
  @Input() currencyList: Currency[] = [];
  @Input() formErrors!: Record<string, string>;
  @Input() customerPaymentMethodList: CustomerPaymentMethodDto[] = [];
  @Input() applyCreditCardList: ApplyCreditCard[] = [];
  @Input() contactLists: ClientAddressCustomize[] = [];
  @Input() customerBillToObject!: ClientSearchList;
  @Input() isCustomerPoRequiredField = false;
  @Output() validationErrorEvent = new EventEmitter();
  @Output() methodPaymentErrorEvent = new EventEmitter();
  @Output() contactListRefreshGrid = new EventEmitter();

  displayAddContact = false;
  addClientContact: AddClientContact = {} as AddClientContact;
  customerAccountNumber = "";
  partyNumber = "";
  applyCreditCardStatus = true;

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  onCurrencyStatus(event: CheckboxChangeEvent) {
    if (event.checked) {
      this.parent.get(["orderDetails", "foreignCurrency"])?.enable();
      this.parent.patchValue({
        orderDetails: {
          foreignCurrencyStatus: true,
        },
      });
    } else {
      this.parent.get(["orderDetails", "foreignCurrency"])?.disable();
      this.parent.patchValue({
        orderDetails: {
          foreignCurrency: "USD",
        },
      });
    }
  }

  onShippingMethodChange(event: SelectChangeEvent) {
    const productObject = this.shippingProductsList.filter(
      x => x.modeCodeD365 == event.value
    );
    if (productObject.length > 0) {
      this.patchValueInShippingMethod(productObject[0].modeDescriptionD365);
    } else {
      this.patchValueInShippingMethod("");
    }
  }

  patchValueInShippingMethod(descriptionName: string) {
    this.parent.patchValue({
      orderDetails: {
        shippingMethodName: descriptionName,
      },
    });
  }

  getCreditCard(event: string) {
    if (event === "CC") {
      this.applyCreditCardStatus = false;
    } else {
      this.applyCreditCardStatus = true;
    }
  }

  // applyBuyerLengthValidation(event: any) {
  //   if (event.target.value) {
  //     this.parent.patchValue({
  //       orderDetails: {
  //         buyer: event.target.value.substring(0, 50),
  //       },
  //     });
  //   }
  // }
  applyCustomerPoLengthValidation(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      this.parent.patchValue({
        orderDetails: {
          customerPONumber: target.value.substring(0, 40),
        },
      });
    }
  }

  // onContactList(contactdropdown: any) {
  //   contactdropdown.open();
  // }

  // onCustomerSelection(name: string, contactdropdown: any) {
  //   contactdropdown.close();
  //   this.parent.patchValue({
  //     orderDetails: {
  //       buyer: name,
  //     },
  //   });
  // }

  addContactInformation() {
    const getBuyerValue: string = this.parent.get([
      "orderDetails",
      "buyer",
    ])?.value;
    if (this.customerBillToObject?.clientAccount && getBuyerValue) {
      const getSplitValues = getBuyerValue.split(" ");
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = getSplitValues[0] || "";
      this.addClientContact.lastName = getSplitValues[1] || "";
      this.addClientContact.type = "Buyer";
    } else {
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = "";
      this.addClientContact.lastName = "";
      this.addClientContact.type = "Buyer";
    }
    this.displayAddContact = true;
  }

  isContactAdded(obj: boolean) {
    if (obj) {
      this.contactListRefreshGrid.emit(true);
    }
  }

  populateContactAddedInfo(obj: string) {
    if (obj) {
      this.parent.patchValue({
        orderDetails: {
          buyer: obj,
        },
      });
    }
  }

  patchValueInCurrency(value = "USD") {
    this.parent.patchValue({
      orderDetails: {
        foreignCurrency: value,
      },
    });
  }
}
